module.exports = __webpack_public_path__ + "img/mike-47.132ead81.jpg";